import { IStyle } from '@fluentui/react';

import { ITimeFilterStyles } from '../TimeFilters/TimeFilters.styles';

export interface IH2OGPTeStyles {
  pivotContainer: IStyle;
}

export const h2ogpteStyles = (): Partial<IH2OGPTeStyles> => ({
  pivotContainer: {
    width: '100%',
    maxWidth: '100%',
    overflowX: 'hidden',
  },
});

export const filterStyles = (): Partial<ITimeFilterStyles> => ({
  filterContainer: {
    marginLeft: 'auto',
    width: 'fit-content',
  },
});
